import React, { useState } from 'react';
import AdminCRUD from '../../components/admin/AdminCRUD';
import I18nForm from '../../components/admin/I18nForm';

const DEPTS = ['operations', 'engineering', 'consulting'];
const TYPES = ['full-time', 'part-time'];
const MODES = ['hybrid', 'remote', 'on-site'];
const LANGS_KEYS = ['en', 'zh-CN', 'zh-TW', 'ja'];

const I18nArrayField = ({ label, value = {}, onChange }) => {
  const [activeLang, setActiveLang] = useState('en');
  const LANGS = [{ key: 'en', label: 'EN' }, { key: 'zh-CN', label: '简中' }, { key: 'zh-TW', label: '繁中' }, { key: 'ja', label: '日本語' }];
  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' }}>{label} (one per line)</label>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '4px' }}>
        {LANGS.map(l => (
          <button key={l.key} type="button" onClick={() => setActiveLang(l.key)}
            style={{ padding: '4px 10px', fontSize: '11px', fontWeight: activeLang === l.key ? 700 : 400, color: activeLang === l.key ? '#3b82f6' : '#64748b', background: 'transparent', border: 'none', borderBottom: activeLang === l.key ? '2px solid #3b82f6' : '2px solid transparent', cursor: 'pointer' }}>
            {l.label}{(value[l.key] && value[l.key].length > 0) ? ' ✓' : ''}
          </button>
        ))}
      </div>
      <textarea
        value={(value[activeLang] || []).join('\n')}
        onChange={e => {
          const arr = e.target.value.split('\n');
          onChange({ ...value, [activeLang]: arr });
        }}
        rows={4}
        style={{ width: '100%', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px 10px', fontSize: '13px', boxSizing: 'border-box' }}
      />
    </div>
  );
};

const blankI18n = () => ({ en: '', 'zh-CN': '', 'zh-TW': '', ja: '' });
const blankI18nArr = () => ({ en: [], 'zh-CN': [], 'zh-TW': [], ja: [] });

const CareerForm = ({ initialData, onSave, onCancel }) => {
  const d = initialData || {};
  const [form, setForm] = useState({
    jobId:           d.jobId           || '',
    title:           d.title           || blankI18n(),
    department:      d.department      || 'operations',
    departmentLabel: d.departmentLabel || blankI18n(),
    type:            d.type            || 'full-time',
    typeLabel:       d.typeLabel       || blankI18n(),
    mode:            d.mode            || 'hybrid',
    modeLabel:       d.modeLabel       || blankI18n(),
    location:        d.location        || blankI18n(),
    summary:         d.summary         || blankI18n(),
    responsibilities:d.responsibilities|| blankI18nArr(),
    requirements:    d.requirements    || blankI18nArr(),
    niceToHave:      d.niceToHave      || blankI18nArr(),
    order:           d.order           || 0,
    isActive:        d.isActive !== false,
  });

  const inputStyle = { width: '100%', border: '1px solid #e2e8f0', borderRadius: '6px', padding: '8px 10px', fontSize: '13px', color: '#334155', outline: 'none', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '12px', fontWeight: 600, color: '#475569', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.4px' };

  return (
    <form onSubmit={e => { e.preventDefault(); onSave(form); }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '14px' }}>
        <div>
          <label style={labelStyle}>Job ID</label>
          <input value={form.jobId} onChange={e => setForm(f => ({ ...f, jobId: e.target.value }))} required style={inputStyle} placeholder="senior-fullstack" />
        </div>
        <div>
          <label style={labelStyle}>Department</label>
          <select value={form.department} onChange={e => setForm(f => ({ ...f, department: e.target.value }))} style={{ ...inputStyle, background: '#fff' }}>
            {DEPTS.map(d => <option key={d}>{d}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Order</label>
          <input type="number" value={form.order} onChange={e => setForm(f => ({ ...f, order: Number(e.target.value) }))} style={inputStyle} />
        </div>
      </div>

      <I18nForm label="Job Title" value={form.title} onChange={v => setForm(f => ({ ...f, title: v }))} />
      <I18nForm label="Location" value={form.location} onChange={v => setForm(f => ({ ...f, location: v }))} />
      <I18nForm label="Summary" value={form.summary} onChange={v => setForm(f => ({ ...f, summary: v }))} multiline rows={3} />

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div>
          <label style={labelStyle}>Employment Type</label>
          <select value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))} style={{ ...inputStyle, background: '#fff' }}>
            {TYPES.map(t => <option key={t}>{t}</option>)}
          </select>
        </div>
        <div>
          <label style={labelStyle}>Work Mode</label>
          <select value={form.mode} onChange={e => setForm(f => ({ ...f, mode: e.target.value }))} style={{ ...inputStyle, background: '#fff' }}>
            {MODES.map(m => <option key={m}>{m}</option>)}
          </select>
        </div>
      </div>

      <I18nArrayField label="Responsibilities" value={form.responsibilities} onChange={v => setForm(f => ({ ...f, responsibilities: v }))} />
      <I18nArrayField label="Requirements" value={form.requirements} onChange={v => setForm(f => ({ ...f, requirements: v }))} />
      <I18nArrayField label="Nice to Have" value={form.niceToHave} onChange={v => setForm(f => ({ ...f, niceToHave: v }))} />

      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', cursor: 'pointer', marginBottom: '20px' }}>
        <input type="checkbox" checked={form.isActive} onChange={e => setForm(f => ({ ...f, isActive: e.target.checked }))} />
        Active
      </label>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button type="submit" style={{ background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', fontWeight: 600, cursor: 'pointer' }}>Save</button>
        <button type="button" onClick={onCancel} style={{ background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: '6px', padding: '9px 20px', fontSize: '13px', cursor: 'pointer' }}>Cancel</button>
      </div>
    </form>
  );
};

const COLUMNS = [
  { key: 'title', label: 'Title (EN)', render: item => item.title?.en || '' },
  { key: 'department', label: 'Dept' },
  { key: 'type', label: 'Type' },
  { key: 'mode', label: 'Mode' },
  { key: 'location', label: 'Location (EN)', render: item => item.location?.en || '' },
  { key: 'isActive', label: 'Active', render: item => item.isActive ? '✅' : '❌' },
];

const AdminCareers = () => (
  <AdminCRUD title="Careers" apiPath="/api/admin/careers" columns={COLUMNS} FormComponent={CareerForm} />
);

export default AdminCareers;
